import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-org-settings-ivrs',
  templateUrl: './org-settings-ivrs.component.html',
  styleUrls: ['./org-settings-ivrs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSettingsIVRsComponent {}

